import cn from 'classnames';

import { CssPageBlock } from '@webapp/common/components/survey-custom';

import css from './container.css';

export const SurveySection: FC<{
    className: string;
    style?: CSSProperties;
    children?: ReactNode;
}> = ({ children, className, style }) => (
    <div className={cn(CssPageBlock.SECTION, css.container, className)} style={style}>
        {children}
    </div>
);
